var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c(
        "div",
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: { loading: _vm.loading, color: _vm.color },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.modalData
        ? _c("customModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modalData,
                expression: "modalData",
              },
            ],
            attrs: {
              onModalClose: _vm.onModalClose,
              onModalAccept: _vm.resetSelectedRunner,
              modalData: _vm.modalData,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.$currentRole != "storeKeeper"
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _vm.runnersWithOutPack
                ? _c("div", { staticClass: "card" }, [
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _vm.runnersWithOutPack
                          ? _c("allRunners", {
                              ref: "runnersWoPacks",
                              attrs: {
                                users: _vm.runnersWithOutPack,
                                selectAll: true,
                                type: "woPacks",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.runnersWithOutPack.length
                          ? _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-success",
                                  on: { click: _vm.setBackPacks },
                                },
                                [_vm._v("Выдать рюкзак(и)")]
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _vm.runnersWithPack
                ? _c("div", { staticClass: "card" }, [
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _vm.runnersWithPack
                          ? _c("allRunners", {
                              attrs: {
                                users: _vm.runnersWithPack,
                                type: "wPacks",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.runnersWithPack.length
                          ? _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-warning",
                                  on: { click: _vm.resetAllPacks },
                                },
                                [_vm._v("Обнулить рюкзаки всех курьеров")]
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", [
            _vm.runnersWithPack && _vm.runnersWithPack.length
              ? _c(
                  "div",
                  { staticClass: "row" },
                  _vm._l(_vm.runnersWithPack, function (runner, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "col-md-12" },
                      [
                        _c("backPack", {
                          attrs: {
                            runner: runner,
                            openModal: _vm.openModal,
                            ordersData: _vm.ordersData,
                            showBackPackOrders: _vm.showBackPackOrders,
                            realisedDrugs: _vm.realisedDrugs[runner.id],
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _c("div", { staticClass: "row" }, [_vm._m(0)]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("back-to-top", { attrs: { bottom: "50px", right: "50px" } }, [
        _c(
          "button",
          { staticClass: "btn btn-info btn-to-top", attrs: { type: "button" } },
          [_c("i", { staticClass: "icon-fa icon-fa-chevron-up" })]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body text-center" }, [
          _c("h5", [_vm._v("Активных рюкзаков нет")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }